module.exports = __webpack_public_path__ + "media/src/images/icons/icons-worker-075f3689e726820a95e88710deb5c970.png";